import React, { Component } from 'react'
import PropTypes from "prop-types";
import { chunk } from "lodash";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import Fab from "@material-ui/core/Fab";
import i18n from 'simple-react-i18n'

export class ListStation extends Component {

	constructor(props) {
		super(props)
		this.state = { page: 0 }
	}

	render() {
		if (this.props.stations.length <= 10) {
			return (
				<div className='collapsible-body no-padding no-margin'>
					{ this.props.stations }
				</div>
			);
		}
		const groups = chunk(this.props.stations, 10)
		return (
			<div className='collapsible-body no-padding no-margin'>
				{ groups[this.state.page] }
				<div style={ { display: 'flex', justifyContent: 'space-between' } }>
					<Fab style={ { margin: '8px' } } children={ <ArrowBackIcon/> } size='small' disabled={ this.state.page === 0 } color='primary' onClick={ () => this.setState({ page: this.state.page-1 }) }/>
					<div>{ i18n.page + ' ' + (this.state.page+1) + ' / ' + groups.length}</div>
					<Fab style={ { margin: '8px' } } children={ <ArrowForwardIcon/> } size='small' disabled={ this.state.page >= groups.length-1 } color='primary' onClick={ () => this.setState({ page: this.state.page+1 }) }/>
				</div>
			</div>
		);
	}

}

ListStation.propTypes = {
	stations: PropTypes.any
}

ListStation.defaultProps = {
	stations: []
}



// WEBPACK FOOTER //
// ./src/components/list/ListStation.js